import { Component, Input } from "@angular/core";
import { faIndustry, faShoppingCart, faUser, faWarehouse } from "@fortawesome/free-solid-svg-icons";
import { faProductHunt } from "@fortawesome/free-brands-svg-icons";

import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

type AdminRoot = "user" | "customer" | "store" | 'project' | 'warehouse'; //  add more if needed

@Component({
  selector: "hawk-record-navigation",
  templateUrl: "./record-navigation.component.html",
  standalone: true,
  imports: [FontAwesomeModule],
  styleUrls: ["./record-navigation.component.scss"],
})
export class RecordNavigationComponent {
  @Input() breadcrumbLinkList: { link: string; description: string }[] = [];
  @Input() leafDescription: string = "";
  @Input() root: AdminRoot = "user";

  icons = {
    user: faUser,
    customer: faIndustry,
    store: faShoppingCart,
    warehouse: faWarehouse,
    project: faProductHunt
  }
}
